import { Loader2, Upload } from "lucide-react";
import { useBulkUpload } from "@/contexts/uploads/BulkUploadContext";
import BulkUploadProgress from "./BulkUploadProgress";

const BulkUploadFloatingBadge = () => {
  const { state, progress, isActive, isPanelOpen, openPanel } = useBulkUpload();

  // Don't show badge if panel is open or no active uploads
  if (!isActive || isPanelOpen) {
    return <BulkUploadProgress />;
  }

  const isProcessing = state.isProcessing && !state.isPaused;

  return (
    <>
      <BulkUploadProgress />

      {/* Floating Badge */}
      <button
        onClick={openPanel}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 px-4 py-3 bg-white rounded-xl shadow-lg border border-gray-200 hover:shadow-xl hover:scale-105 transition-all duration-200"
      >
        {/* Progress Ring / Icon */}
        <div className="relative">
          {isProcessing ? (
            <Loader2 className="h-5 w-5 text-genie-primary animate-spin" />
          ) : (
            <Upload className="h-5 w-5 text-genie-primary" />
          )}
        </div>

        {/* Status Text */}
        <div className="text-left">
          <p className="text-sm font-medium text-gray-900">
            {isProcessing
              ? `Uploading ${progress.inProgress + progress.pending} files...`
              : state.isPaused
                ? "Upload paused"
                : `${progress.pending} files ready`}
          </p>
          <p className="text-xs text-gray-500">
            {progress.completed > 0 && `${progress.completed} completed`}
            {progress.failed > 0 && progress.completed > 0 && ", "}
            {progress.failed > 0 && <span className="text-red-600">{progress.failed} failed</span>}
            {progress.completed === 0 && progress.failed === 0 && "Click to view"}
          </p>
        </div>

        {/* Mini Progress Bar */}
        {isProcessing && (
          <div className="w-16 h-1.5 bg-gray-200 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-genie-primary to-genie-secondary transition-all duration-300"
              style={{ width: `${progress.overallProgress}%` }}
            />
          </div>
        )}
      </button>
    </>
  );
};

export default BulkUploadFloatingBadge;
